import React, { useState } from 'react';
import {} from 'reactstrap';
import PageBreadcrumb from '../../../Components/Common/PageBreadcrumb';
import '../../TenderOpening/components/TenderOpening.css';
// This page lists Product Hydro clarifications only (ProcurementTypeHeader = 1,
// set in ProductHydro).
import ProductHydro from './ProductHydro';

const ImprovementClarification = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb
                fallback={{
                  label: 'Improvement Clarification',
                  to: '/apps-improvementclarification/view',
                }}
              />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-question-answer-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>Improvement Clarification</h4>
                  <p className='to-hero-subtitle'>
                    Respond to improvement and clarification requests on your
                    offers and follow their status until closing.
                  </p>
                </div>
                <button
                  type='button'
                  className='to-hero-btn'
                  onClick={handleRefresh}
                >
                  <i className='ri-refresh-line' aria-hidden='true' />
                  Refresh
                </button>
              </div>
            </div>

            <ProductHydro
              refreshTrigger={refreshTrigger}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(ImprovementClarification);
